import {
	usePolicies,
	PolicyEditor,
	PolicyViewerHeader,
	DocumentViewer,
	VisualizeButton,
	SaveButton,
	PolicyToggle,
	TypeSelection,
	usePolicyNewLogic,
} from '@practium/features/policy';
import { PoliciesLayout } from '../layouts/PoliciesLayout';

export const PolicyNewPage = () => {
	const {
		filteredPolicies,
		isLoading,
		updatingPolicyId,
		handleSearch,
		handleTogglePolicy,
		selectPolicy,
		saveNewPolicy,
		addTemporaryPolicy,
		updateTemporaryPolicy,
		removeTemporaryPolicy,
	} = usePolicies();

	const {
		selectedType,
		newPolicy,
		isPreviewMode,
		handleSave,
		handleVisualize,
		handlePolicyChange,
		handleAddPolicy,
		handleToggle,
		handleCardToggle,
		handleSelectPolicy,
		handleTypeSelect,
	} = usePolicyNewLogic({
		saveNewPolicy,
		addTemporaryPolicy,
		updateTemporaryPolicy,
		removeTemporaryPolicy,
		handleTogglePolicy,
		selectPolicy,
	});

	const documentKey = newPolicy ? `${newPolicy._id}-${newPolicy.isActive}` : 'empty';

	if (!selectedType || !newPolicy) {
		return (
			<PoliciesLayout
				policies={filteredPolicies}
				selectedPolicy={null}
				isLoading={isLoading}
				updatingPolicyId={updatingPolicyId}
				onSearch={handleSearch}
				onTogglePolicy={handleCardToggle}
				onSelectPolicy={handleSelectPolicy}
				onAddPolicy={handleAddPolicy}
				headerContent={
					<PolicyViewerHeader mode="edit">
						<div />
					</PolicyViewerHeader>
				}
			>
				<TypeSelection onSelect={handleTypeSelect} />
			</PoliciesLayout>
		);
	}

	const headerContent = (
		<PolicyViewerHeader mode={isPreviewMode ? 'view' : 'edit'}>
			<PolicyToggle checked={newPolicy.isActive} onChange={handleToggle} />
			<VisualizeButton onClick={handleVisualize}>
				{isPreviewMode ? 'Editar' : 'Visualizar'}
			</VisualizeButton>
			<SaveButton onClick={handleSave}>Salvar</SaveButton>
		</PolicyViewerHeader>
	);

	return (
		<PoliciesLayout
			policies={filteredPolicies}
			selectedPolicy={newPolicy}
			isLoading={isLoading}
			updatingPolicyId={updatingPolicyId}
			onSearch={handleSearch}
			onTogglePolicy={handleCardToggle}
			onSelectPolicy={handleSelectPolicy}
			onAddPolicy={handleAddPolicy}
			headerContent={headerContent}
		>
			{isPreviewMode ? (
				<DocumentViewer policy={newPolicy} key={`viewer-${newPolicy._id}-${newPolicy.isActive}`} />
			) : (
				<PolicyEditor
					policy={newPolicy}
					onChange={handlePolicyChange}
					key={`edit-${documentKey}`}
				/>
			)}
		</PoliciesLayout>
	);
};
